import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from "@sentry/angular"; // ADD3003
import { BrowserTracing } from "@sentry/tracing"; // ADD3003


import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

 // ADD3003
Sentry.init({
  dsn: "https://539ef5035095477c8f708f6d2ee4f750@o332080.ingest.sentry.io/6295796",
  integrations: [
    new BrowserTracing({
      tracingOrigins: ["localhost", "https://yourserver.io/api", "https://signup.contalink.com"],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
 // ADD3003

//platformBrowserDynamic().bootstrapModule(AppModule) // CMT3003
//    .catch(err => console.log(err));				 // CMT3003
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(success => console.log(`Bootstrap success`))
  .catch(err => console.error(err));